// Google Sheets API service

export const getSheetData = async () => {
  try {
    const response = await fetch('/sheets-products')
    if (!response.ok) throw new Error('Failed to load products')
    return await response.json()
  } catch (error) {
    console.error('Error loading sheet data:', error)
    // Return demo data if API fails
    return getDemoProducts()
  }
}

const getDemoProducts = () => [
  { 
    id: 'prod_a_std', 
    name: 'Product A', 
    category: 'Main', 
    variant: 'Standard', 
    price: 299, 
    description: 'Basic analytics suite with core reporting features',
    contractDetails: 'This agreement covers the Standard edition of Product A, providing basic analytics capabilities including dashboard creation, standard reports, and data visualization tools. Support is provided during business hours with a 24-hour response time.'
  },
  { 
    id: 'prod_a_ent', 
    name: 'Product A', 
    category: 'Main', 
    variant: 'Enterprise', 
    price: 599, 
    description: 'Advanced analytics with AI-powered insights and predictions',
    contractDetails: 'This agreement covers the Enterprise edition of Product A, featuring advanced analytics with machine learning capabilities, predictive modeling, custom report builders, and API access. Premium support is included with 4-hour response time and dedicated account management.'
  },
  { 
    id: 'prod_b_std', 
    name: 'Product B', 
    category: 'Main', 
    variant: 'Standard', 
    price: 399, 
    description: 'Cloud platform starter with essential infrastructure',
    contractDetails: 'This agreement covers the Standard edition of Product B, providing scalable cloud infrastructure with auto-scaling capabilities, standard security features, and 99.9% uptime SLA. Includes 1TB of storage and standard bandwidth allocation.'
  },
  { 
    id: 'prod_b_ent', 
    name: 'Product B', 
    category: 'Main', 
    variant: 'Enterprise', 
    price: 799, 
    description: 'Cloud platform pro with advanced features and scaling',
    contractDetails: 'This agreement covers the Enterprise edition of Product B, featuring unlimited scaling, advanced security with SOC2 compliance, 99.99% uptime SLA, dedicated infrastructure options, and 10TB included storage with unlimited bandwidth.'
  },
  { 
    id: 'prod_c_std', 
    name: 'Product C', 
    category: 'Main', 
    variant: 'Standard', 
    price: 199, 
    description: 'Integration hub for connecting your applications',
    contractDetails: 'This agreement covers the Standard edition of Product C, enabling integration with up to 50 third-party services, standard data transformation tools, and scheduled synchronization. Includes 100,000 monthly transactions.'
  },
  { 
    id: 'prod_c_ent', 
    name: 'Product C', 
    category: 'Main', 
    variant: 'Enterprise', 
    price: 499, 
    description: 'Advanced integration platform with custom connectors',
    contractDetails: 'This agreement covers the Enterprise edition of Product C, featuring unlimited integrations, custom connector development, real-time synchronization, advanced data mapping, and unlimited transactions. Includes professional services for custom integration development.'
  },
  { 
    id: 'ext_backup', 
    name: 'Backup Service', 
    category: 'External', 
    price: 99, 
    description: 'Automated daily backups with 30-day retention',
    contractDetails: 'Automated backup service providing daily snapshots of all data with 30-day retention period. Includes instant recovery capabilities and geo-redundant storage across multiple regions.'
  },
  { 
    id: 'ext_monitor', 
    name: 'Monitoring', 
    category: 'External', 
    price: 149, 
    description: '24/7 system monitoring with instant alerts',
    contractDetails: 'Comprehensive monitoring service covering application performance, infrastructure health, and security events. Real-time alerting via email, SMS, and webhook integrations with detailed analytics dashboard.'
  },
  { 
    id: 'ext_support', 
    name: 'Premium Support', 
    category: 'External', 
    price: 299, 
    description: 'Dedicated support team with priority response',
    contractDetails: 'Premium support package including dedicated account team, 1-hour response time for critical issues, quarterly business reviews, and proactive optimization recommendations.'
  },
  { 
    id: 'ext_training', 
    name: 'Training Package', 
    category: 'External', 
    price: 199, 
    description: 'Monthly training sessions and documentation',
    contractDetails: 'Comprehensive training program including monthly instructor-led sessions, access to online learning platform, custom documentation, and certification programs for your team.'
  },
  { 
    id: 'ext_custom', 
    name: 'Custom Integration', 
    category: 'External', 
    price: 399, 
    description: 'Custom API development and integration services',
    contractDetails: 'Professional services for custom integration development, including requirements analysis, API design, implementation, testing, and ongoing maintenance. Includes up to 40 hours of development per month.'
  }
]